"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MercadoPagoBasisTheoryChallenge = MercadoPagoBasisTheoryChallenge;
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _challenge = require("./challenge");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CHALLENGE_TIMEOUT_MS = 5 * 60 * 1000;
var nextFrameId = 0;

/** Authenticate one BT payment; only Purchase can determine the payment result. */
function MercadoPagoBasisTheoryChallenge(_ref) {
  var challenge = _ref.challenge,
    paymentId = _ref.paymentId,
    onComplete = _ref.onComplete,
    onError = _ref.onError,
    onStarted = _ref.onStarted;
  var _useTranslation = (0, _reactI18next.useTranslation)('payment'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    finishedPaymentId = _useState2[0],
    setFinishedPaymentId = _useState2[1];
  var dialogRef = (0, _react.useRef)(null);
  var iframeRef = (0, _react.useRef)(null);
  var formRef = (0, _react.useRef)(null);
  var callbacks = (0, _react.useRef)({
    onComplete: onComplete,
    onError: onError,
    onStarted: onStarted
  });
  var attempt = (0, _react.useRef)();

  // Freeze the initial challenge for each payment so receipt rerenders cannot replay the POST.
  if (!attempt.current || attempt.current.paymentId !== paymentId) {
    nextFrameId += 1;
    attempt.current = {
      paymentId: paymentId,
      frameName: "mercadopago-bt-3ds-".concat(nextFrameId),
      challenge: (0, _challenge.validateMercadoPagoBasisTheoryChallengeData)(challenge)
    };
  }
  var currentAttempt = attempt.current;
  (0, _react.useEffect)(function () {
    callbacks.current = {
      onComplete: onComplete,
      onError: onError,
      onStarted: onStarted
    };
  }, [onComplete, onError, onStarted]);
  (0, _react.useEffect)(function () {
    var dialog = dialogRef.current;
    if (!dialog || !currentAttempt.challenge || finishedPaymentId === currentAttempt.paymentId) return undefined;
    var previousFocus = document.activeElement;
    function containFocus(event) {
      if (event.target instanceof Node && !(dialog !== null && dialog !== void 0 && dialog.contains(event.target))) dialog === null || dialog === void 0 || dialog.focus();
    }
    function enterChallenge(event) {
      if (event.key === 'Tab' && event.target === dialog) {
        var _iframeRef$current;
        event.preventDefault();
        (_iframeRef$current = iframeRef.current) === null || _iframeRef$current === void 0 || _iframeRef$current.focus();
      }
    }
    document.addEventListener('focusin', containFocus);
    dialog.addEventListener('keydown', enterChallenge);
    dialog.focus();
    return function () {
      document.removeEventListener('focusin', containFocus);
      dialog.removeEventListener('keydown', enterChallenge);
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus();
    };
  }, [currentAttempt, finishedPaymentId]);
  (0, _react.useEffect)(function () {
    var _iframeRef$current2, _callbacks$current$on, _callbacks$current;
    if (finishedPaymentId === currentAttempt.paymentId) return undefined;
    var validatedChallenge = currentAttempt.challenge;
    var form = formRef.current;
    var iframeWindow = (_iframeRef$current2 = iframeRef.current) === null || _iframeRef$current2 === void 0 ? void 0 : _iframeRef$current2.contentWindow;
    if (!validatedChallenge || !form || !iframeWindow) {
      currentAttempt.challenge = undefined;
      setFinishedPaymentId(currentAttempt.paymentId);
      callbacks.current.onError('invalid_challenge');
      return undefined;
    }
    var expectedOrigin = new URL(validatedChallenge.url).origin;
    var settled = false;
    var timeoutId;
    function cleanup() {
      window.removeEventListener('message', receiveCompletion);
      window.clearTimeout(timeoutId);
    }
    function fail(reason) {
      if (settled) return;
      settled = true;
      cleanup();
      currentAttempt.challenge = undefined;
      setFinishedPaymentId(currentAttempt.paymentId);
      callbacks.current.onError(reason);
    }
    function receiveCompletion(event) {
      if (settled || event.source !== iframeWindow || event.origin !== expectedOrigin) return;
      var data = event.data;
      if ((0, _typeof2["default"])(data) !== 'object' || data === null || !('status' in data)) return;
      if (data.status !== 'COMPLETE') return;
      settled = true;
      cleanup();
      currentAttempt.challenge = undefined;
      setFinishedPaymentId(currentAttempt.paymentId);
      callbacks.current.onComplete();
    }
    window.addEventListener('message', receiveCompletion);
    timeoutId = window.setTimeout(function () {
      fail('timeout');
    }, CHALLENGE_TIMEOUT_MS);
    try {
      form.submit();
    } catch (_unused) {
      fail('submission_failed');
    }
    // Submission failure has already cleared the challenge.
    if (currentAttempt.challenge) (_callbacks$current$on = (_callbacks$current = callbacks.current).onStarted) === null || _callbacks$current$on === void 0 || _callbacks$current$on.call(_callbacks$current);
    return function () {
      settled = true;
      cleanup();
      currentAttempt.challenge = undefined;
    };
  }, [currentAttempt, finishedPaymentId]);
  if (!currentAttempt.challenge) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: dialogRef,
    tabIndex: -1,
    role: "dialog",
    "aria-modal": "true",
    "aria-label": t('secure_payment'),
    className: "fixed inset-0 z-[1000] flex overflow-y-auto bg-[#ededed] p-4",
    "data-sentry-component": "MercadoPagoBasisTheoryChallenge",
    "data-sentry-source-file": "MercadoPagoBasisTheoryChallenge.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "m-auto flex max-h-[calc(100dvh-2rem)] w-full max-w-[458px] flex-col gap-4"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "m-0 shrink-0 text-xl font-semibold leading-snug sm:text-2xl text-[#191919]"
  }, t('bank_validation_title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "m-0 flex shrink-0 items-start gap-3 rounded-md border-l-4 border-[#3483fa] bg-[#e5e5e5] p-4 text-sm leading-5 text-[#191919]"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    viewBox: "0 0 20 20",
    className: "h-5 w-5 shrink-0",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "MercadoPagoBasisTheoryChallenge.tsx"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    fill: "#3483fa",
    "data-sentry-element": "circle",
    "data-sentry-source-file": "MercadoPagoBasisTheoryChallenge.tsx"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 9v5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    "data-sentry-element": "path",
    "data-sentry-source-file": "MercadoPagoBasisTheoryChallenge.tsx"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "10",
    cy: "6",
    r: "1",
    fill: "white",
    "data-sentry-element": "circle",
    "data-sentry-source-file": "MercadoPagoBasisTheoryChallenge.tsx"
  })), t('bank_validation_keep_open')), /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true",
    tabIndex: 0,
    onFocus: function onFocus() {
      var _iframeRef$current3;
      return (_iframeRef$current3 = iframeRef.current) === null || _iframeRef$current3 === void 0 ? void 0 : _iframeRef$current3.focus();
    }
  }), /*#__PURE__*/_react["default"].createElement("iframe", {
    key: currentAttempt.frameName,
    ref: iframeRef,
    name: currentAttempt.frameName,
    title: t('secure_payment'),
    className: "h-[365px] min-h-[160px] w-full shrink rounded-lg border-0 bg-white"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true",
    tabIndex: 0,
    onFocus: function onFocus() {
      var _iframeRef$current4;
      return (_iframeRef$current4 = iframeRef.current) === null || _iframeRef$current4 === void 0 ? void 0 : _iframeRef$current4.focus();
    }
  }), /*#__PURE__*/_react["default"].createElement("form", {
    ref: formRef,
    method: "POST",
    action: currentAttempt.challenge.url,
    target: currentAttempt.frameName,
    hidden: true
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "hidden",
    name: "creq",
    value: currentAttempt.challenge.creq,
    readOnly: true
  }))));
}
// oxlint-disable-next-line import/no-default-export -- Public API consumed by the checkout processor.
var _default = exports["default"] = MercadoPagoBasisTheoryChallenge;